/**
 * The policies in the consumer's plan with their status (existing, selected, kept without applying,
 * application submitted), and the added quote among them, from the live client and the saved plan.
 */
import { useMemo } from 'react';
import { deriveConsumerPolicies } from '@shared/consumerPlan';
import { useConsumerClient } from './use-consumer-client';
import { useConsumerPlan } from './use-consumer-plan';

export function useConsumerPolicies(clientId: string) {
  const { client } = useConsumerClient(clientId);
  const { plan, applications } = useConsumerPlan(clientId);
  const ltcPolicies = client?.multipleFundingSources?.ltcPolicy;
  const selectedQuoteKey = plan?.selectedQuoteKey ?? null;
  const continuedWithoutApplyingQuoteKey = plan?.continuedWithoutApplyingQuoteKey ?? null;

  const policies = useMemo(
    () =>
      deriveConsumerPolicies({
        ltcPolicies,
        selectedQuoteKey,
        continuedWithoutApplyingQuoteKey,
        applications,
      }),
    [ltcPolicies, selectedQuoteKey, continuedWithoutApplyingQuoteKey, applications],
  );
  const addedQuote = policies.find(entry => entry.status !== 'existing-policy') ?? null;

  return { policies, addedQuote, applications };
}
